import AboutContainer from './AboutContainer'

export default AboutContainer
